import { jsx } from 'react/jsx-runtime';
import { HORIZONTAL_GROUP_LABEL_HEIGHT } from '@shopify/polaris-viz-core';

const VerticalGridLines = ({
  chartHeight,
  ticks,
  xScale,
  stroke
}) => {
  return /*#__PURE__*/jsx("g", {
    transform: `translate(0, ${HORIZONTAL_GROUP_LABEL_HEIGHT})`,
    "aria-hidden": "true",
    children: ticks.map((value, index) => {
      if (value === 0) {
        return null;
      }
      return /*#__PURE__*/jsx("line", {
        y1: 0,
        y2: chartHeight - HORIZONTAL_GROUP_LABEL_HEIGHT,
        stroke: stroke,
        transform: `translate(${xScale(value)},0)`
      }, index);
    })
  });
};

export { VerticalGridLines };
